import React, { useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
//import { selectModuleTabs, setSelectedTemplate } from "../../../../redux/slices/ModulesTabSlices";
// import { selectModuleTabs, } from "../../../../redux/selectors/tabsSelectors";
// import { setSelectedTemplate } from "../../../../redux/slices/messagesSlice";
import { selectModuleTabs } from "../../../../redux/selectors/tabsSelectors";
import { setSelectedTemplate } from "../../../../redux/slices/messagesSlice";

const TemplatesMessages = () => {
    // Redux State (Persists across reloads/navigation)
    const dispatch = useDispatch();
    const { selectedTemplate } = useSelector(selectModuleTabs("messages"));
    
// Ensure selectedTemplate is a string or null
if (selectedTemplate && typeof selectedTemplate !== 'string') {
  console.error("Invalid selectedTemplate value:", selectedTemplate);
  dispatch(setSelectedTemplate(null)); // Reset to null if invalid
}
  
    // Local State (Temporary, component-only)
    const [messageType, setMessageType] = useState("");
    const [customMessage, setCustomMessage] = useState("");
  
    const templateOptions = [
      "Customer Response",
      "Order Confirmation",
      "Shipping Update"
    ];
  
    const messageTypes = [
      "Urgent",
      "Follow-up",
      "Informational"
    ];
  
    return (
      <div className="p-4 space-y-6">
        {/* Redux-connected Dropdown */}
        <div className="mb-8">
          <h3 className="text-lg font-bold mb-4">Template Selection (Redux)</h3>
          <div className="max-w-xs">
            <label className="block text-sm font-medium mb-2">
              Saved Templates:
            </label>
            <select
              value={selectedTemplate || ""}
              onChange={(e) => 
                dispatch(setSelectedTemplate(e.target.value)) // Pass only the template value
              }
              className="w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Choose a template</option>
              {templateOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
          {selectedTemplate && (
            <div className="mt-4 p-4 bg-gray-50 rounded-md">
              <h4 className="font-medium mb-2">Persistent Selection:</h4>
              <p className="text-gray-700">{selectedTemplate}</p>
            </div>
          )}
        </div>
  
        {/* Local State Components */}
        <div className="border-t pt-6">
          <h3 className="text-lg font-bold mb-4">Message Composition (Local State)</h3>
          
          {/* Local Dropdown */}
          <div className="max-w-xs mb-4">
            <label className="block text-sm font-medium mb-2">
              Message Type:
            </label>
            <select
              value={messageType}
              onChange={(e) => setMessageType(e.target.value)}
              className="w-full p-2 border rounded-md focus:ring-2 focus:ring-green-500"
            >
              <option value="">Select type</option>
              {messageTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
  
          {/* Local Text Field */}
          <div className="max-w-md mb-4">
            <label className="block text-sm font-medium mb-2">
              Custom Message:
            </label>
            <input
              type="text"
              value={customMessage}
              onChange={(e) => setCustomMessage(e.target.value)}
              placeholder="Type your message..."
              className="w-full p-2 border rounded-md focus:ring-2 focus:ring-green-500"
            />
          </div>
  
          {(messageType || customMessage) && (
            <div className="mt-4 p-4 bg-green-50 rounded-md">
              <h4 className="font-medium mb-2">Temporary Preview:</h4>
              {messageType && <p className="text-green-700">Type: {messageType}</p>}
              {customMessage && <p className="text-green-700 mt-2">Message: {customMessage}</p>}
            </div>
          )}
        </div>
      </div>
    );
  };
  
  export default TemplatesMessages;